module.exports = __webpack_public_path__ + "static/jan_3-8b8a0fee26b36eeb2bbe594b6d2fad61.mp4";